import React, { useState } from "react";
import PropTypes from "prop-types";
import { Title, Fieldset, Button, Control, Field, Column, Label } from "rbx";
import { useMutation, useApolloClient } from "react-apollo";
import { SystemCodeSelect, BooleanInput } from "../inputs";
import {
  CREATE_INSPECTION_MASTER_MUTATION,
  ALL_INSPECTION_MASTER_QUERY
} from "../../graphql/InspectionMaster/InspectionMaster.graphql";
import { CREATE_INSPECTION_MUTATION } from "../../graphql/Inspections/Inspections.graphql";
import { ourToast as toast } from "../../utils";

const DEFAULT_STATE = {
  InspecCdRecIdRef: null,
  VehicleTypeRecIdRef: null,
  OdometerReq: false,
  Active: true
};

const AddInspectionMasterForm = ({ onComplete }) => {
  const [inputs, setInputs] = useState({ ...DEFAULT_STATE });
  const client = useApolloClient();
  const [createNewInspectionMaster, res] = useMutation(
    CREATE_INSPECTION_MASTER_MUTATION,
    {
      refetchQueries: ["ALL_INSPECTION_MASTER_QUERY"]
    }
  );

  const onChange = e => {
    const { name } = e.target;
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [name]: value });
  };

  const handleSave = async e => {
    e.preventDefault();
    try {
      if (inputs && inputs.InspecCdRecIdRef && inputs.VehicleTypeRecIdRef) {
        const {
          data: { InspectionMasters }
        } = await client.query({
          query: ALL_INSPECTION_MASTER_QUERY,
          variables: {
            where: {
              InspecCdRecIdRef: parseInt(inputs.InspecCdRecIdRef),
              VehicleTypeRecIdRef: parseInt(inputs.VehicleTypeRecIdRef)
            },
            first: 1
          },
          fetchPolicy: "network-only"
        });
        if (InspectionMasters && InspectionMasters.length > 0) {
          toast.error("This Inspection Master already exists.");
        } else {
          const {
            data: InspectionMasterData
          } = await createNewInspectionMaster({
            variables: {
              data: {
                Active: inputs.Active || inputs.Active === "on",
                InspecCdRecIdRef: parseInt(inputs.InspecCdRecIdRef, 10),
                VehicleTypeRecIdRef: parseInt(inputs.VehicleTypeRecIdRef, 10),
                OdometerReq: inputs.OdometerReq
              }
            }
          });
          await client.mutate({
            mutation: CREATE_INSPECTION_MUTATION,
            variables: {
              data: {
                LineItem: 1,
                Description: "",
                InspectionMasterRecIdRef:
                  InspectionMasterData.createInspectionMaster.RecId,
                InspecCdRecIdRef: parseInt(inputs.InspecCdRecIdRef, 10),
                VehicleTypeRecIdRef: parseInt(inputs.VehicleTypeRecIdRef, 10),
                Active: true
              }
            }
          });
          toast.success("Inspection Master created successfully.");
          onComplete();
        }
      } else {
        toast.error("You have to select Inspection Type and Vehicle Type.");
      }
    } catch (err) {
      console.log(err);
      toast.error("Error creating Inspection Master.");
    }
  };

  return (
    <form
      className="add-item-form inspection-modal-master-container"
      id="add-item-form"
      onSubmit={handleSave}
    >
      <Title>New Inspection Master</Title>
      <Fieldset disabled={res.loading}>
        <Column.Group>
          <Column>
            <Control expanded>
              <SystemCodeSelect
                icon="globe"
                label="Inspection Code"
                lookup={{ Category: "Inventory", Code: "InspectionCd" }}
                name="InspecCdRecIdRef"
                size=""
                value={inputs?.InspecCdRecIdRef}
                onChange={onChange}
              />
            </Control>
          </Column>
          <Column>
            <Control expanded>
              <SystemCodeSelect
                icon="truck"
                label="Vehicle Type"
                lookup={{ Category: "Fleet", Code: "VehicleType" }}
                name="VehicleTypeRecIdRef"
                size=""
                value={inputs?.VehicleTypeRecIdRef}
                onChange={onChange}
              />
            </Control>
          </Column>
        </Column.Group>
        <Column.Group>
          <Column>
            <Control expanded>
              <Label>Odometer Reading Required</Label>
              <BooleanInput
                name="OdometerReq"
                value={inputs.OdometerReq}
                onChange={onChange}
              />
            </Control>
          </Column>
          <Column>
            <Control expanded>
              <Label>Active</Label>
              <BooleanInput
                name="Active"
                value={inputs.Active}
                onChange={onChange}
              />
            </Control>
          </Column>
        </Column.Group>
        <hr />
        <Field kind="group">
          <Control>
            <Button color="primary" form="add-item-form" type="submit">
              Submit
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AddInspectionMasterForm.propTypes = {
  onComplete: PropTypes.func
};
export default AddInspectionMasterForm;
